import { Action, createAction } from 'redux-act';

import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import SpecialHour from '../../../models/interfaces/SpecialHour';
import TimestampPayload from '../TimestampPayload';
import SpecialHourAction from './SpecialHourAction';

export interface DeleteSpecialHourPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHour: SpecialHour;
}
export const deleteSpecialHour = createAction<DeleteSpecialHourPayload>('DELETE_SPECIAL_HOUR');
export type DeleteSpecialHourActionType = Action<DeleteSpecialHourPayload>;

export interface SpecialHourDeletedPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHour: SpecialHour;
  affectedReservations: SeatedReservation[];
}
export const specialHourDeleted = createAction<SpecialHourDeletedPayload>('SPECIAL_HOUR_DELETED');

export interface SpecialHourDeleteFailedPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHourUuid: string;
}
export const specialHourDeleteFailed = createAction<SpecialHourDeleteFailedPayload>('SPECIAL_HOUR_DELETE_FAILED');
